import React from 'react';
var Tooltip = function (_a) {
    var data = _a.data, content = _a.content, showTooltip = _a.showTooltip;
    var itemStyle = data.itemStyle, options = data.options, galleryScrollY = data.galleryScrollY, offsetLeft = data.offsetLeft;
    var tooltipStyles = { opacity: 0 };
    var getStyles = function () {
        var _a;
        var gallerySpacing = (options === null || options === void 0 ? void 0 : options.layoutParams).gallerySpacing;
        var scrollY = galleryScrollY || 0;
        gallerySpacing = gallerySpacing || 0;
        var itemCenter = itemStyle.width / 2 + gallerySpacing;
        var translate = {
            x: options.isRTL ? '50%' : '-50%',
            y: -gallerySpacing + 10,
        };
        var itemLeft = offsetLeft - scrollY;
        var direction = options.isRTL ? 'right' : 'left';
        return _a = {},
            _a[direction] = "".concat(itemLeft, "px"),
            _a.transform = "translate(calc(".concat(translate.x, " ").concat(options.isRTL ? '-' : '+', "\n      ").concat(itemCenter, "px), calc(-100% - ").concat(translate.y, "px))"),
            _a.opacity = showTooltip ? 1 : 0,
            _a.transition = "opacity ".concat(showTooltip ? '2s' : '500ms'),
            _a;
    };
    if (itemStyle && options) {
        tooltipStyles = getStyles();
    }
    return (React.createElement("div", { className: "tooltip-wrapper", style: tooltipStyles, "aria-hidden": true },
        React.createElement("div", { className: "tooltip-body arrow" }, content)));
};
export default Tooltip;
//# sourceMappingURL=tooltip.js.map